import { Route, Routes } from "react-router-dom";
import Cadastro from "./Cadastro";
import Consulta from "./Consulta";

export default function Servico() {
    return <>
        <Routes>
            <Route path="/" element={<Consulta />}></Route>
            <Route path="/adicionar" element={<Cadastro />}></Route>
            <Route path="/alterar/:codigo" element={<Cadastro />}></Route>
        </Routes>
    </>;
}